export const ORDER_STATUS_OPTIONS = [
  "paid",
  "packed",
  "in_transit",
  "delivered",
  "cancelled"
];

export const PRODUCT_CATEGORIES = [
  'productCategoryYogaMats',
  'productCategoryYogaBlocks',
  'productCategoryYogaStraps',
  'productCategoryResistanceBands',
  'productCategoryPilatesRings',
  'productCategoryFoamRollers',
  'productCategoryOthers'
];

export const ADMIN_LIST_PAGE_SIZE = 10;
export const SIDEBAR_GROUP_STORAGE_KEY = "ft_admin_sidebar_groups";

export const ADMIN_PAGINATION_KEYS = ["positions", "userManagement", "products", "orders", "customers", "banners", "collectedProducts"];

export const MAX_FAQ_KNOWLEDGE_ITEMS = 8;
export const MAX_FAQ_QUESTION_LENGTH = 150;
export const MAX_FAQ_ANSWER_LENGTH = 500;
export const MAX_COMPANY_IMAGE_ITEMS = 30;

export const DEFAULT_FAQ_KNOWLEDGE_ITEMS = [
  {
    question: 'faqSampleOrderQ',
    answer: 'faqSampleOrderA'
  },
  {
    question: 'faqCustomPackagingQ',
    answer: 'faqCustomPackagingA'
  },
  {
    question: 'faqLeadTimeQ',
    answer: 'faqLeadTimeA'
  },
  {
    question: 'faqDefectiveItemQ',
    answer: 'faqDefectiveItemA'
  },
  {
    question: 'faqWhyChooseUsQ',
    answer: 'faqWhyChooseUsA'
  }
];

export const DEFAULT_COMPANY_IMAGE_SECTIONS = [
  {
    key: 'companyOverview',
    labelEn: 'companyImageSectionOverview',
    labelZh: 'companyImageSectionOverview',
    enabled: true,
    images: []
  },
  {
    key: 'competitiveAdvantages',
    labelEn: 'companyImageSectionAdvantages',
    labelZh: 'companyImageSectionAdvantages',
    enabled: true,
    images: []
  },
  {
    key: 'customizationCapabilities',
    labelEn: 'companyImageSectionCustomization',
    labelZh: 'companyImageSectionCustomization',
    enabled: true,
    images: []
  },
  {
    key: 'extendedCompanyProfile',
    labelEn: 'companyImageSectionExtended',
    labelZh: 'companyImageSectionExtended',
    enabled: true,
    images: []
  },
  {
    key: 'packagingShipping',
    labelEn: 'companyImageSectionPackaging',
    labelZh: 'companyImageSectionPackaging',
    enabled: true,
    images: []
  },
  {
    key: 'factoryProfile',
    labelEn: 'companyImageSectionFactory',
    labelZh: 'companyImageSectionFactory',
    enabled: false,
    images: []
  },
  {
    key: 'productionWorkflow',
    labelEn: 'companyImageSectionWorkflow',
    labelZh: 'companyImageSectionWorkflow',
    enabled: false,
    images: []
  },
  {
    key: 'tradeShow',
    labelEn: 'companyImageSectionTradeShow',
    labelZh: 'companyImageSectionTradeShow',
    enabled: false,
    images: []
  }
];

export const DEFAULT_COMPANY_IMAGE_SECTION_MAP = DEFAULT_COMPANY_IMAGE_SECTIONS.reduce((result, item) => {
  result[item.key] = {
    labelZh: String(item.labelZh || "").trim(),
    labelEn: String(item.labelEn || "").trim()
  };
  return result;
}, {});

export const DEFAULT_ADMIN_LIST_PAGES = ADMIN_PAGINATION_KEYS.reduce((result, key) => {
  result[key] = 1;
  return result;
}, {});

export const STOREFRONT_CONFIG_UPDATED_EVENT = "storefront-config-updated";
export const STOREFRONT_CONFIG_UPDATED_AT_KEY = "ft_storefront_config_updated_at";
export const MAX_NAV_DEPTH = 3;

export const MENU_EMOJI_BY_KEY = {
  home: "🏠",
  storeDesign: "🎨",
  companyProfile: "🏢",
  storeBase: "🧩",
  templateStudio: "🧪",
  articleManagement: "📝",
  companyImages: "🖼️",
  designNav: "🧭",
  designCarousel: "🏷️",
  faqKnowledge: "📚",
  products: "📦",
  productCreate: "➕",
  merchandising: "🧠",
  procurement: "🛒",
  quality: "✅",
  logistics: "🚚",
  orders: "🧾",
  customers: "👥",
  marketing: "📣",
  discounts: "💸",
  finance: "💳",
  analytics: "📊",
  settings: "⚙️",
  workTargets: "🎯",
  workProcessing: "🛠️",
  hrEmployee: "🧑‍💼",
  hrRecruitment: "🧲",
  hrAttendance: "🕒",
  hrOffice: "🏢",
  siteMaintenance: "🧱",
  permissionMaintenance: "🛡️",
  positionMaintenance: "👥",
  profile: "👤",
  password: "🔐",
  inquiry: "💬",
  wishlist: "⭐",
  orderProcessing: "📑",
  afterSales: "🧰"
};

export const POSITION_TEMPLATE_CAPABILITIES = {
  common: ["shop:profile:read", "shop:password:write"],
  internal: [
    "internal:work:targets:read",
    "internal:work:processing:read"
  ],
  guest: ["shop:inquiry:write", "shop:wishlist:read"],
  customer: [
    "shop:inquiry:write",
    "shop:wishlist:read",
    "shop:orders:processing:read",
    "shop:after-sales:read"
  ]
};

const CUSTOMER_MANAGEMENT_CAPABILITIES = [
  "admin:users:read",
  "crm:customer:read",
  "crm:customer:write",
  "crm:customer:assign"
];

const MARKETING_MANAGEMENT_CAPABILITIES = [
  "marketing:campaign:read",
  "marketing:campaign:write",
  "marketing:coupon:write",
  "marketing:lead:export"
];

const ANALYTICS_MANAGEMENT_CAPABILITIES = [
  "analytics:dashboard:read",
  "analytics:report:export"
];

const NOTIFICATION_MANAGEMENT_CAPABILITIES = ["office:announcement:write"];

const POSITION_MANAGEMENT_CAPABILITIES = [
  "internal:maintenance:position:write",
  "internal:maintenance:permission:write",
  "admin:users:role:write",
  "admin:users:position:assign"
];

const INQUIRY_MANAGEMENT_CAPABILITIES = [
  "sales:inquiry:read",
  "sales:inquiry:reply",
  "support:ticket:read",
  "support:ticket:write",
  "support:complaint:handle"
];

export const TAB_CAPABILITY_RULES = {
  home: ["admin:overview:read"],
  storeBase: ["admin:storefront:read", "admin:storefront:write"],
  templateStudio: ["admin:storefront:read", "admin:storefront:write"],
  articleManagement: ["admin:storefront:read", "admin:storefront:write", "website:content:write"],
  companyImages: ["admin:storefront:read", "admin:storefront:write"],
  designNav: ["admin:storefront:read", "admin:storefront:write"],
  designCarousel: ["admin:storefront:read", "admin:storefront:write"],
  faqKnowledge: ["admin:storefront:read", "admin:storefront:write", "website:content:write"],
  products: ["admin:products:read", "admin:products:write"],
  productCreate: ["admin:products:create", "admin:products:write"],
  merchandising: ["merchandising:selection:read", "merchandising:selection:write", "admin:products:read", "admin:products:write", "admin:products:create"],
  procurement: ["procurement:purchase:write"],
  quality: ["qa:inspection:write"],
  solutions: ["qa:inspection:write"],
  logistics: ["logistics:tracking:read", "logistics:shipment:write"],
  orders: ["admin:orders:read", "admin:orders:write"],
  ordersPaidQueue: ["admin:orders:read", "admin:orders:write"],
  ordersInTransit: ["admin:orders:read", "admin:orders:write"],
  ordersCompleted: ["admin:orders:read", "admin:orders:write"],
  ordersAfterSales: ["admin:orders:read", "admin:orders:write"],
  customers: CUSTOMER_MANAGEMENT_CAPABILITIES,
  customersSegments: CUSTOMER_MANAGEMENT_CAPABILITIES,
  customersTags: CUSTOMER_MANAGEMENT_CAPABILITIES,
  marketing: MARKETING_MANAGEMENT_CAPABILITIES,
  marketingPoster: ["marketing:campaign:write", "marketing:lead:export"],
  marketingEmail: ["marketing:campaign:write", "marketing:lead:export"],
  discounts: ["marketing:coupon:write", "marketing:campaign:write"],
  finance: ["finance:payment:read", "finance:payment:write", "finance:reconciliation:write", "finance:invoice:read", "finance:tax:write"],
  financeIncome: ["finance:payment:read", "finance:payment:write"],
  financeExpenses: ["finance:payment:read", "finance:payment:write"],
  financeReceivables: ["finance:payment:read", "finance:reconciliation:write"],
  financePayables: ["finance:payment:read", "finance:payment:write"],
  financeInvoices: ["finance:invoice:read", "finance:invoice:write"],
  financeTax: ["finance:tax:write", "finance:invoice:read"],
  financeBudget: ["finance:payment:read", "finance:payment:write"],
  financeDaily: ["finance:payment:read", "finance:reconciliation:write"],
  financeMonthly: ["finance:payment:read", "finance:reconciliation:write"],
  financeYearly: ["finance:payment:read", "finance:reconciliation:write", "finance:tax:write"],
  financeReconciliation: ["finance:reconciliation:write", "finance:invoice:read", "finance:tax:write"],
  financeApprovals: ["finance:refund:approve", "finance:reconciliation:write"],
  financeReports: ["analytics:report:export", "finance:payment:read", "finance:invoice:read"],
  analytics: ANALYTICS_MANAGEMENT_CAPABILITIES,
  analyticsSales: ANALYTICS_MANAGEMENT_CAPABILITIES,
  analyticsProducts: ANALYTICS_MANAGEMENT_CAPABILITIES,
  analyticsCustomers: ANALYTICS_MANAGEMENT_CAPABILITIES,
  notifications: NOTIFICATION_MANAGEMENT_CAPABILITIES,
  notificationPlan: NOTIFICATION_MANAGEMENT_CAPABILITIES,
  settings: ["admin:system-config:read", "admin:system-config:write"],
  workTargets: ["internal:work:targets:read"],
  workProcessing: ["internal:work:processing:read"],
  hrEmployee: ["hr:employee:read", "hr:employee:write", "admin:users:read"],
  hrRecruitment: ["hr:recruitment:manage"],
  hrAttendance: ["hr:attendance:manage"],
  hrOffice: ["office:announcement:write", "office:document:read", "office:document:write", "office:meeting:manage"],
  siteMaintenance: ["internal:maintenance:site:write"],
  positionMaintenance: POSITION_MANAGEMENT_CAPABILITIES,
  profile: ["shop:profile:read"],
  password: ["shop:password:write"],
  inquiry: ["shop:inquiry:write", ...INQUIRY_MANAGEMENT_CAPABILITIES],
  wishlist: ["shop:wishlist:read"],
  orderProcessing: ["shop:orders:processing:read"],
  afterSales: ["shop:after-sales:read"]
};

export const CAPABILITIES_BY_ROLE = {
  developer: [
    "admin:overview:read",
    "admin:products:read",
    "admin:products:write",
    "merchandising:selection:read",
    "merchandising:selection:write",
    "procurement:purchase:write",
    "qa:inspection:write",
    "logistics:shipment:write",
    "logistics:tracking:read",
    "admin:orders:read",
    "admin:orders:write",
    "admin:users:read",
    "admin:users:write",
    "admin:users:role:write",
    "admin:users:position:assign",
    "admin:users:password:reset",
    "admin:users:delete",
    "admin:storefront:read",
    "admin:storefront:write",
    "admin:system-config:read",
    "admin:system-config:write",
    "finance:invoice:read",
    "finance:invoice:write",
    "finance:payment:read",
    "finance:payment:write",
    "finance:refund:approve",
    "finance:reconciliation:write",
    "finance:tax:write",
    "analytics:report:export",
    "office:announcement:write",
    "internal:maintenance:site:write",
    "internal:maintenance:permission:write",
    "internal:maintenance:position:write"
  ],
  "super-admin": [
    "admin:overview:read",
    "admin:products:read",
    "admin:products:write",
    "merchandising:selection:read",
    "merchandising:selection:write",
    "procurement:purchase:write",
    "qa:inspection:write",
    "logistics:shipment:write",
    "logistics:tracking:read",
    "admin:orders:read",
    "admin:orders:write",
    "admin:users:read",
    "admin:users:write",
    "admin:users:role:write",
    "admin:users:position:assign",
    "admin:users:password:reset",
    "admin:storefront:read",
    "admin:storefront:write",
    "admin:system-config:read",
    "finance:invoice:read",
    "finance:invoice:write",
    "finance:payment:read",
    "finance:payment:write",
    "finance:refund:approve",
    "finance:reconciliation:write",
    "finance:tax:write",
    "analytics:report:export",
    "office:announcement:write",
    "internal:maintenance:site:write",
    "internal:maintenance:permission:write",
    "internal:maintenance:position:write"
  ],
  admin: [
    "admin:overview:read",
    "admin:products:read",
    "admin:products:write",
    "admin:orders:read",
    "admin:orders:write",
    "admin:storefront:read",
    "admin:storefront:write",
    "admin:users:read",
    "finance:invoice:read",
    "finance:payment:read",
    "finance:reconciliation:write"
  ],
  customer: ["shop:profile:read", "shop:password:write", "shop:orders:read"],
  guest: ["shop:products:read", "shop:storefront:read"]
};

export const ASSIGNABLE_ROLES = ["developer", "super-admin", "admin", "customer", "guest"];

export const ROLE_LEVELS = {
  developer: 5,
  "super-admin": 4,
  admin: 3,
  customer: 2,
  guest: 1
};

export const POSITION_LIST_STORAGE_KEY = "ft_admin_position_list";
export const HR_RECRUITMENT_STAGE_STORAGE_KEY = "ft_hr_recruitment_stage_map";
export const HR_ATTENDANCE_OVERRIDE_STORAGE_KEY = "ft_hr_attendance_override_map";
export const HR_ANNOUNCEMENTS_STORAGE_KEY = "ft_hr_announcements";
export const HR_DOCUMENT_UPLOADS_STORAGE_KEY = "ft_hr_document_uploads";
export const HR_RECRUITMENT_STAGE_OPTIONS = ["needs_position", "screening", "interview", "offer", "onboarded"];

export const DEFAULT_POSITION_ROWS = [
  {
    id: 1,
    name: "运营专员",
    key: "operations-specialist",
    department: "运营部",
    permissions: [
      "admin:products:read",
      "admin:products:write",
      "admin:products:create",
      "website:content:read",
      "website:content:write",
      "website:navigation:write",
      "website:banner:write",
      "website:seo:write",
      "website:publish",
      "marketing:campaign:read",
      "marketing:campaign:write",
      "analytics:dashboard:read"
    ]
  },
  {
    id: 2,
    name: "选品采购专员",
    key: "merchandising-procurement-specialist",
    department: "供应链中心",
    permissions: [
      "analytics:dashboard:read",
      "merchandising:selection:read",
      "merchandising:selection:write",
      "admin:products:read",
      "admin:products:write",
      "admin:products:create",
      "catalog:pricing:write",
      "catalog:inventory:write",
      "catalog:translation:write",
      "procurement:purchase:write",
      "qa:inspection:write",
      "logistics:shipment:write",
      "logistics:tracking:read"
    ]
  },
  {
    id: 3,
    name: "业务员",
    key: "sales-executive",
    department: "销售部",
    permissions: [
      "sales:inquiry:read",
      "sales:inquiry:reply",
      "sales:quotation:create",
      "sales:contract:write",
      "crm:customer:read",
      "crm:customer:write"
    ]
  },
  {
    id: 4,
    name: "人力行政专员",
    key: "hr-admin-specialist",
    department: "人力行政部",
    permissions: [
      "admin:users:read",
      "admin:users:write",
      "admin:users:position:assign",
      "admin:users:password:reset",
      "internal:maintenance:position:write",
      "hr:employee:read",
      "hr:employee:write",
      "hr:attendance:manage",
      "hr:recruitment:manage",
      "office:announcement:write",
      "office:document:read",
      "office:document:write",
      "office:meeting:manage"
    ]
  }
];

export const POSITION_SCOPED_MENU_TABS = {
  "ops-admin": ["home", "products", "productCreate", "orders", "ordersPaidQueue", "ordersInTransit", "ordersCompleted", "ordersAfterSales", "storeBase", "templateStudio", "articleManagement", "companyImages", "faqKnowledge", "designNav", "designCarousel", "analytics"],
  "operations-specialist": ["home", "storeBase", "templateStudio", "articleManagement", "companyImages", "faqKnowledge", "designNav", "designCarousel", "marketing", "marketingPoster", "marketingEmail", "discounts", "analytics"],
  "supervisor": ["home", "products", "productCreate", "orders", "ordersPaidQueue", "ordersInTransit", "ordersCompleted", "ordersAfterSales", "inquiry", "analytics"],
  "merchandise-selection-specialist": ["home", "products", "productCreate", "merchandising"],
  "merchandising-procurement-specialist": ["home", "products", "productCreate", "merchandising", "procurement", "solutions", "logistics", "analytics"],
  "sourcing-specialist": ["home", "products", "procurement", "solutions"],
  "merchandiser": ["home", "orders", "ordersPaidQueue", "ordersInTransit", "ordersCompleted", "ordersAfterSales", "logistics", "workProcessing"],
  "logistics-specialist": ["home", "logistics", "workProcessing"],
  "sales-rep": ["home", "customers", "customersSegments", "customersTags", "inquiry", "workProcessing"],
  "sales-executive": ["home", "customers", "customersSegments", "customersTags", "inquiry", "workProcessing"],
  "sales-manager": ["home", "customers", "customersSegments", "customersTags", "inquiry", "analytics", "analyticsSales", "analyticsCustomers", "workProcessing"],
  "finance-specialist": ["home", "finance", "financeIncome", "financeExpenses", "financeReceivables", "financePayables", "financeInvoices", "financeTax", "financeBudget", "financeDaily", "financeMonthly", "financeReconciliation"],
  "finance-manager": ["home", "finance", "financeIncome", "financeExpenses", "financeReceivables", "financePayables", "financeInvoices", "financeTax", "financeBudget", "financeDaily", "financeMonthly", "financeYearly", "financeReconciliation", "financeApprovals", "financeReports", "analytics", "analyticsSales", "analyticsCustomers"],
  "service-agent": ["home", "inquiry", "workProcessing"],
  "marketing-specialist": ["home", "storeBase", "templateStudio", "articleManagement", "companyImages", "faqKnowledge", "designNav", "designCarousel", "marketing", "marketingPoster", "marketingEmail", "discounts"],
  "hr-specialist": ["home", "hrEmployee", "hrRecruitment", "hrAttendance", "hrOffice", "notifications", "notificationPlan"],
  "hr-admin-specialist": ["home", "hrEmployee", "hrRecruitment", "hrAttendance", "hrOffice", "customers", "positionMaintenance", "notifications", "notificationPlan"],
  "it-admin": ["home", "settings", "siteMaintenance"],
  "general-manager": ["home", "analytics", "analyticsSales", "analyticsProducts", "analyticsCustomers", "financeApprovals", "financeReports", "positionMaintenance", "siteMaintenance"]
};